module.exports = "<template>\r\n    Redirecting...\r\n</template>";


//////////////////
// WEBPACK FOOTER
// ./ClientApp/app/components/home/home.html
// module id = app/components/home/home.html
// module chunks = 0